import React from 'react';

import { DragDropContext } from 'react-beautiful-dnd';

export const DragDropContextWrapper: React.FC<any> = ({ onDrag, children }) => {
  return onDrag ? <DragDropContext onDragEnd={onDrag}>{children}</DragDropContext> : <div>{children}</div>;
};
